/* unplugin-vue-components disabled */import { render } from "./builder.vue?vue&type=template&id=0f983072&scoped=true"
import script from "./builder.vue?vue&type=script&setup=true&lang=js"
export * from "./builder.vue?vue&type=script&setup=true&lang=js"

import "./builder.vue?vue&type=style&index=0&id=0f983072&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f983072"],['__file',"src/components/builder/builder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f983072"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f983072', __exports__)) {
    api.reload('0f983072', __exports__)
  }
  
  module.hot.accept("./builder.vue?vue&type=template&id=0f983072&scoped=true", () => {
    api.rerender('0f983072', render)
  })

}


export default __exports__